import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { GraduationCap } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TENANT_LOGO_EVENT = 'tenant-logo-updated';

export const SidebarBrand = ({ user, testId }) => {
  const [brand, setBrand] = useState(null);
  const [failed, setFailed] = useState(false);
  const load = useCallback(() => {
    if (!user?.tenant_id || user.role === 'SUPER_ADMIN') return;
    axios.get(`${API}/tenant/brand`).then((r) => { setBrand({ ...r.data, bust: Date.now() }); setFailed(false); }).catch(() => setBrand(null));
  }, [user?.tenant_id, user?.role]);
  useEffect(() => {
    load();
    window.addEventListener(TENANT_LOGO_EVENT, load);
    return () => window.removeEventListener(TENANT_LOGO_EVENT, load);
  }, [load]);
  const showLogo = brand?.has_logo && !failed;
  return (
    <div className="flex items-center flex-shrink-0 px-4 gap-2" data-testid={testId}>
      {showLogo ? (
        <img src={`${API}/public/tenant-logo/${user.tenant_id}?v=${brand.bust}`} alt="Logo de l'établissement" onError={() => setFailed(true)}
             className="w-9 h-9 object-contain rounded" data-testid={`${testId}-tenant-logo`} />
      ) : (
        <GraduationCap className="w-8 h-8 text-blue-600" />
      )}
      <div className="min-w-0">
        <span className="text-xl font-bold block leading-tight">EduScope</span>
        {brand?.name && <span className="text-xs text-gray-500 block truncate max-w-[150px]" title={brand.name} data-testid={`${testId}-tenant-name`}>{brand.name}</span>}
      </div>
    </div>
  );
};

export default SidebarBrand;
